import { 
  fetchTicketApi, 
  deleteTicketActivityByAdminApi, 
  ticketReplyByAdminApi, 
  editUserApi, 
  fetchTicketFeedbackSummaryApi, 
  fetchAllTicketCategoryApi,
  addTicketCategoryApi,
  updateTicketCategoryApi,
  deleteTicketCategoryApi,
  AddTicketCategoryRequest,
  UpdateTicketCategoryRequest,
} from "services/ticketService";

import {  
  fetchSingleTicketData,
  fetchTicketData, 
  setPagination, 
  setTicketLoader, 
  ticketSuccessMsg ,
  ticketErrorMsg,
  setTicketFeedbackSummary,
  setTicketCategoryLoader,
  ticketCategorySuccess,
  ticketCategoryError,
  setTicketCategories,
  setLastCreatedCategoryId,
  } from "./reducer";
import { setI18n } from "react-i18next";
// import { fetchLocationDataSuccess } from "slices/auditeeLocation/reducer";


export const fetchTicket = (data: any) => async (dispatch: any) => {
  // export const fetchUserData = (data: any, guid: string, selectedTab: string) => async (dispatch: any) => {
  dispatch(setTicketLoader(true));
  try {
    const response = await fetchTicketApi(data);
    if (response.success) {

      if (data.ticket_id != 0) {
        dispatch(fetchSingleTicketData(response));
        dispatch(setPagination(response.data.pagination));
      }

      else if (data.status == "") {
        dispatch(fetchTicketData(response));
        dispatch(setPagination(response.data.pagination));
      }

      else {
        dispatch(fetchTicketData(response));
        dispatch(setPagination(response.data.pagination))
      }

    }
  } catch (fetchTicketError: any) {
    const errorMessage = fetchTicketError?.message || fetchTicketError?.response?.data?.message || "Something went wrong";
    dispatch(ticketErrorMsg({message:errorMessage, id: Date.now()}));
  } finally {
  }
  dispatch(setTicketLoader(false));
};

export const deleteTicketActivityByAdmin = (activityId: number) => async (dispatch: any) => {
  dispatch(setTicketLoader(true));
  try {
    const response = await deleteTicketActivityByAdminApi(activityId);

    if (response.success) {
      dispatch(
        ticketSuccessMsg({
          message: response.message || "Activity deleted successfully",
          id: Date.now(),
        })
      );
      // Optionally refetch the updated ticket activities
      // dispatch(fetchTicket(updatedTicketParams));
    } else {
      dispatch(
        ticketErrorMsg({
          message: response.message || "Failed to delete activity",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    const errorMessage =
      error?.message ||
      error?.response?.data?.message ||
      "Something went wrong while deleting activity";
    dispatch(ticketErrorMsg({ message: errorMessage, id: Date.now() }));
  } finally {
    dispatch(setTicketLoader(false));
  }
};

export const ticketReplyByAdmin = (data: {
  ticket_id: number;
  activity_description: string;
  status: string;
  attachment_url?: string | null;
}) => async (dispatch: any) => {
  dispatch(setTicketLoader(true));
  try {
    const response = await ticketReplyByAdminApi(data);

    if (response.success) {
      if(data.activity_description==="Ticket Closed by Admin"){
     dispatch(
        ticketSuccessMsg({
          message: "Ticket closed successfully",
          id: Date.now(),
        })
      );
      }
      else if(data.activity_description==="Ticket Reopened by Admin"){
     dispatch(
        ticketSuccessMsg({
          message: "Ticket Reopened successfully",
          id: Date.now(),
        })
      );
      }

      else if(data.activity_description!=="Ticket closed by Admin"){
        dispatch(
          ticketSuccessMsg({
            message: "Relpy sent successfully",
            id: Date.now(),
          })
        );
      }
      const payload = {
            ticket_id: data.ticket_id || 0,
            "activity_description": "",
            "ticket_no": "",
            "status": "",
            "phone_no": "",
            "from_date": "",
            "to_date": "",
            "page": 1,
            "page_size": 10,
        }
        dispatch(fetchTicket(payload));
      // Optionally refresh ticket details
      // dispatch(fetchTicket({ ticket_id: data.ticket_id }));
    } else {
      dispatch(
        ticketErrorMsg({
          message: response.message || "Failed to send reply",
          id: Date.now(),
        })
      );  
    }
  } catch (error: any) {
    const errorMessage =
      error?.message ||
      error?.response?.data?.message ||
      "Something went wrong while replying to ticket";
    dispatch(ticketErrorMsg({ message: errorMessage, id: Date.now() }));
  } finally {
    dispatch(setTicketLoader(false));
  }
};
export const fetchTicketFeedbackSummary = (data: any) => async (dispatch: any) => {
  dispatch(setTicketLoader(true));

  try {
    const response = await fetchTicketFeedbackSummaryApi(data);

    if (response.success) {
      dispatch(setTicketFeedbackSummary(response.data));
    } else {
      dispatch(
        ticketErrorMsg({
          message: response.message || "Failed to fetch ticket feedback summary",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    const errorMessage =
      error?.message ||
      error?.response?.data?.message ||
      "Something went wrong while fetching feedback summary";

    dispatch(ticketErrorMsg({ message: errorMessage, id: Date.now() }));
  } finally {
    dispatch(setTicketLoader(false));
  }
};

export const fetchTicketCategories = () => async (dispatch: any) => {
  dispatch(setTicketCategoryLoader(true));
  let res: any;

  try {
    const categories = await fetchAllTicketCategoryApi(); // returns array
    dispatch(setTicketCategories(categories));
    res = { success: true, data: categories };
  } catch (error: any) {
    dispatch(
      ticketCategoryError({
        message: error?.message || "Error while fetching ticket categories",
        id: Date.now(),
      })
    );
    res = { success: false, message: error?.message };
  } finally {
    dispatch(setTicketCategoryLoader(false));
  }

  return res;
};

export const createTicketCategory =
  (data: AddTicketCategoryRequest) => async (dispatch: any) => {
    dispatch(setTicketCategoryLoader(true));
    let res: any;

    try {
      res = await addTicketCategoryApi(data);

      if (res?.success !== false) {
        dispatch(setLastCreatedCategoryId(Number(res?.data) || null));
        dispatch(
          ticketCategorySuccess({
            message: res?.message || "Category created successfully",
            id: Date.now(),
          })
        );
        dispatch(fetchTicketCategories() as any);
      } else {
        dispatch(
          ticketCategoryError({
            message: res?.message || "Failed to create category",
            id: Date.now(),
          })
        );
      }
    } catch (error: any) {
      dispatch(
        ticketCategoryError({
          message: error?.message || "Error while creating category",
          id: Date.now(),
        })
      );
      res = { success: false, message: error?.message };
    } finally {
      dispatch(setTicketCategoryLoader(false));
    }

    return res;
  };

  export const editTicketCategory =
  (data: UpdateTicketCategoryRequest) => async (dispatch: any) => {
    dispatch(setTicketCategoryLoader(true));
    let res: any;

    try {
      res = await updateTicketCategoryApi(data);

      if (res?.success !== false) {
        dispatch(
          ticketCategorySuccess({
            message: res?.message || "Category updated successfully",
            id: Date.now(),
          })
        );
        dispatch(fetchTicketCategories() as any);
      } else {
        dispatch(
          ticketCategoryError({
            message: res?.message || "Failed to update category",
            id: Date.now(),
          })
        );
      }
    } catch (error: any) {
      dispatch(
        ticketCategoryError({
          message: error?.message || "Error while updating category",
          id: Date.now(),
        })
      );
      res = { success: false, message: error?.message };
    } finally {
      dispatch(setTicketCategoryLoader(false));
    }

    return res;
  };

  export const deleteTicketCategory =
  (categoryid: number) => async (dispatch: any) => {
    dispatch(setTicketCategoryLoader(true));
    let res: any;

    try {
      res = await deleteTicketCategoryApi(categoryid);

      if (res?.success !== false) {
        dispatch(
          ticketCategorySuccess({
            message: res?.message || "Category deleted successfully",
            id: Date.now(),
          })
        );
        dispatch(fetchTicketCategories() as any);
      } else {
        dispatch(
          ticketCategoryError({
            message: res?.message || "Failed to delete category",
            id: Date.now(),
          })
        );
      }
    } catch (error: any) {
      dispatch(
        ticketCategoryError({
          message: error?.message || "Error while deleting category",
          id: Date.now(),
        })
      );
      res = { success: false, message: error?.message };
    } finally {
      dispatch(setTicketCategoryLoader(false));
    }
    return res;
  };
